import React from 'react';

const ProductMainImage = ({ activeGalleryPhoto, fadeIn, fadeOut }) => {
  return (
    <div className="product-img-container m-1">
      <img
        src={activeGalleryPhoto}
        className={[
          'center-image center-image-slider',
          fadeIn ? ' fade-in' : '',
          fadeOut ? ' fade-out' : ''
        ].join('')}
        alt={activeGalleryPhoto}
      />
    </div>
  );
};

export default ProductMainImage;
